import { render } from "./index.vue?vue&type=template&id=12a7d518&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=12a7d518&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a7d518"]])

export default __exports__